import { ApiResponse, post } from "../helpers";
import { LanguageRestrictionsModel } from "../models/registrationModel";
import { LanguageEndPoints } from "./configEndPoints";

const getLanguageRestrictionsAndResponses = async (): Promise<
  ApiResponse<LanguageRestrictionsModel>
> => {
  return post<void, LanguageRestrictionsModel>(
    LanguageEndPoints.GetLanguageRestrictionsAndResponses,
    undefined as void
  );
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const LanguageApi = {
  getLanguageRestrictionsAndResponses,
};

export default LanguageApi;
